module.exports = __webpack_public_path__ + "img/reattachFile.3d6b4d8a.svg";